/**
 * Brand quote (handoff §7, `template.html:653-658`). One block for every audience of the
 * catalog section, with no attribution line.
 *
 * Full-bleed section on the section background, same sangria technique as the hero: `width:
 * var(--vpW)` plus a negative `margin-left` to break out of the shell's max width.
 */

const QUOTE =
  "Presentear é fazer parte de uma história que começa a ser contada à mesa. Uma peça escolhida com carinho acompanha o casal por muitos encontros.";

export function CatalogBrandQuote() {
  return (
    <section className="mt-[clamp(52px,6vw,80px)] w-screen [margin-inline:calc(50%-50vw)] bg-[var(--tb-porcelain-tint)] px-[clamp(20px,4vw,56px)] py-[clamp(52px,6vw,80px)]">
      <div className="mx-auto max-w-[720px] text-center">
        <p className="font-display text-[clamp(23px,2.6vw,32px)] font-light leading-[1.35] text-[var(--fg)] [text-wrap:pretty]">
          {QUOTE}
        </p>
      </div>
    </section>
  );
}
